import { Spinner } from '@isyc-react/design/bootstrap';
import { DocumentalTypologyResult } from '@isyc-react/types';
import { nsnewo } from "../../../i18n/namespaces";
import { ArchiveInputState } from "../../types/deprecated-documental-validation";
import React from 'react';
import { useTranslation } from 'react-i18next';
export const DocumentalValidationStatus = props => {
  const {
    documentalTypologyResult,
    archiveInputState
  } = props;
  const {
    t
  } = useTranslation(nsnewo.common);
  switch (archiveInputState) {
    case ArchiveInputState.Uploading:
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spinner, {
        className: "text-primary me-2",
        size: "sm"
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-start text-xl-end"
      }, t('newo.documentalTypologyResult.uploading')));
    case ArchiveInputState.Failed:
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", {
        className: "mdi mdi-exclamation mdi-24px text-red pe-3"
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-start text-xl-end"
      }, t('newo.documentalTypologyResult.failed')));
    case ArchiveInputState.Uploaded:
      return /*#__PURE__*/React.createElement(React.Fragment, null, (documentalTypologyResult === DocumentalTypologyResult.TYPOLOGY_RESULT_IN_PROGRESS || documentalTypologyResult === DocumentalTypologyResult.TYPOLOGY_RESULT_NO_INFO) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", {
        className: "mdi mdi-clock-outline mdi-24px text-yellow pe-3"
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-start text-xl-end"
      }, t('newo.documentalTypologyResult.pending'))), documentalTypologyResult === DocumentalTypologyResult.TYPOLOGY_RESULT_VALID && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", {
        className: "mdi mdi-check mdi-24px pe-3 text-green"
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-start text-xl-end text-green"
      }, t('newo.documentalTypologyResult.valid'))), documentalTypologyResult === DocumentalTypologyResult.TYPOLOGY_RESULT_INVALID && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", {
        className: "mdi mdi-close mdi-24px pe-3 text-red"
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-start text-xl-end text-red"
      }, t('newo.documentalTypologyResult.invalid'))));
    default:
      return /*#__PURE__*/React.createElement(React.Fragment, null, "No info");
  }
};